import { jsx as _jsx } from "react/jsx-runtime";
import { Suspense, lazy } from 'react';
import { Loading } from 'components/atoms/loading';
import { useAiFeatureFlags } from 'hooks/use-feature-flags';
import { NotFound } from '../404';
import { SecureRoute } from '../route-with-permission-check';
import { ROUTE_PATHS } from '../routes-paths';
// Lazy: this route is statically imported into `app-routes.tsx` via
// `analyticsAgentRoutes`, so any value imports here land in the app shell.
// The conversation page in particular drags @progress/kendo-react-pdf (~639 kB),
// highcharts (~281 kB), and the 307-module ai-analytics organism. Behind
// `import()` instead.
const AIAnalyticsPage = /*#__PURE__*/ lazy(()=>import('components/pages/ai-analytics').then((m)=>({
            default: m.AIAnalyticsPage
        })));
const AIAnalyticsConversationPage = /*#__PURE__*/ lazy(()=>import('components/pages/ai-analytics').then((m)=>({
            default: m.AIAnalyticsConversationPage
        })));
function AnalyticsAgentGate({ children }) {
    const { isNitroAnalystEnabled, isLoadingFlags } = useAiFeatureFlags();
    if (isLoadingFlags) {
        return /*#__PURE__*/ _jsx(Loading, {});
    }
    if (!isNitroAnalystEnabled) {
        return /*#__PURE__*/ _jsx(NotFound, {});
    }
    return /*#__PURE__*/ _jsx(SecureRoute, {
        rule: "AI_ANALYST:WRITE",
        children: children
    });
}
export const analyticsAgentRoutes = [
    {
        path: `${ROUTE_PATHS.AI_ANALYTICS}`,
        element: /*#__PURE__*/ _jsx(AnalyticsAgentGate, {
            children: /*#__PURE__*/ _jsx(Suspense, {
                fallback: /*#__PURE__*/ _jsx(Loading, {}),
                children: /*#__PURE__*/ _jsx(AIAnalyticsPage, {})
            })
        })
    },
    {
        path: `${ROUTE_PATHS.AI_ANALYTICS}/:conversationId`,
        element: /*#__PURE__*/ _jsx(AnalyticsAgentGate, {
            children: /*#__PURE__*/ _jsx(Suspense, {
                fallback: /*#__PURE__*/ _jsx(Loading, {}),
                children: /*#__PURE__*/ _jsx(AIAnalyticsConversationPage, {})
            })
        })
    }
];
